import { useEffect } from 'react';

declare global {
  interface Window {
    heap?: any;
    __heapEventQueue?: Array<() => void>;
    __heapListenerAttached?: boolean;
  }
}

const useHeapTrack = (eventName: string, properties?: Record<string, any>) => {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const trackEvent = () => {
      window.heap?.track?.(eventName, properties);
    };

    // If heap is ready, track immediately
    if (window.heap?.track) {
      trackEvent();
    } else {
      // Queue the event
      window.__heapEventQueue = window.__heapEventQueue || [];
      window.__heapEventQueue.push(trackEvent);

      // Only add listener once to flush the queue when heap is ready
      if (!window.__heapListenerAttached) {
        window.__heapListenerAttached = true;

        const checkHeapReady = setInterval(() => {
          if (window.heap?.track) {
            clearInterval(checkHeapReady);
            window.__heapEventQueue?.forEach(fn => fn());
            window.__heapEventQueue = [];
          }
        }, 100);
      }
    }
  }, [eventName, properties]);
};

export default useHeapTrack;
